import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CheckoutFormService } from '../../../checkout-form-service/checkout-form.service';
import { View } from '../view.enum';
import { CardOnFile } from '../../card-on-file';
import { CreditCardProcessingService } from 'src/app/shared/credit-card-processing/credit-card-processing.service';
import { CreditCardProcessingMethod } from 'src/app/shared/credit-card-processing-method.enum';

@Component({
    selector: 'ols-saved-cards',
    templateUrl: './saved-cards.component.html',
    styleUrls: ['./saved-cards.component.scss'],
})
export class SavedCardsComponent implements OnInit {
    @Input() surchargeSettings: {
        surchargeEnabled: boolean;
        surchargeRate: number;
    };
    private _cardsOnFile: CardOnFile[];
    public get cardsOnFile(): CardOnFile[] {
        return this._cardsOnFile;
    }
    @Input() public set cardsOnFile(cards: CardOnFile[]) {
        if (cards?.length > 0) {
            if (this.form && this.cardOnFile) {
                this.setCardOnFile(cards);
            }
            this._cardsOnFile = cards;
        }
    }
    @Output() viewChange: EventEmitter<View> = new EventEmitter();
    @Input() isLoading: boolean;
    form: FormGroup;

    constructor(
        private formService: CheckoutFormService,
        private creditCardProcessingService: CreditCardProcessingService
    ) {}

    get cardOnFile(): FormControl {
        return this.form?.get('cardOnFile') as FormControl;
    }

    shouldShowSurchargeBanner(): boolean {
        return (
            this.surchargeSettings?.surchargeEnabled &&
            this.surchargeSettings?.surchargeRate > 0 &&
            this.creditCardProcessingService.getCreditCardProcessingMethod() ===
                CreditCardProcessingMethod.Stripe
        );
    }

    ngOnInit(): void {
        this.form = this.formService.createCardsOnFileForm();
        if (this.cardsOnFile && this.cardsOnFile.length > 0) {
            this.setCardOnFile(this.cardsOnFile);
        }
    }

    private setCardOnFile(cards: CardOnFile[]): void {
        if (cards && cards.length > 0) {
            this.cardOnFile.setValue(cards[0].id);
        }
    }

    public addCard(): void {
        this.viewChange.emit(View.ADD_CARD);
    }
}
